import React from 'react';
import { useSelector } from 'react-redux';

import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { PreparedCategoryData } from 'utils';
import { CategoryCard, CardClickHandler, CardType } from 'common/components';
import { selectPageModelRegionId } from 'store/pageModel';
import { selectWindowType } from 'store/pageStore';
import { usePopularCategories } from '../../hooks';
import { usePopularCategoriesSliderAnalytics } from './hooks';
import { SliderButton } from './slider-button';

import {
	PopularCategoryCardMoscow,
	PopularCategoryCardRegion,
	SwiperContainer,
	SwiperWrapper,
} from './styles';

export const PopularCategoriesSlider = () => {
	const {
		handleInitSwiper,
		handleChangeSlide,
		categoriesData,
		ref,
	} = usePopularCategoriesSliderAnalytics();
	const { setModalData, openModal } = usePopularCategories();

	const regionId = useSelector(selectPageModelRegionId);
	const isMoscow = Number(regionId) === 34;

	const windowType = useSelector(selectWindowType);

	let spaceBetweenWOS: number;

	if (windowType === 'mobile') {
		spaceBetweenWOS = 12;
	} else if (windowType === 'tablet' || windowType === 'laptop') {
		spaceBetweenWOS = 20;
	} else {
		spaceBetweenWOS = 32;
	}

	const spaceBetween = isMoscow ? 20 : spaceBetweenWOS;
	const cardType = isMoscow ? CardType.popularOrder : CardType.popular;

	const onClickCard: CardClickHandler = (data: PreparedCategoryData) => {
		if (!isMoscow) {
			openModal();
			setModalData(data);
		}
	};

	const getVisibleSlidesIndexes = slides => {
		const visibleSlidesIndexes: number[] = [];
		slides.forEach((slide, i) => {
			if (slide.classList.contains('swiper-slide-visible')) {
				visibleSlidesIndexes.push(i);
			}
		});
		return visibleSlidesIndexes;
	};
	return (
		<SwiperWrapper ref={ref} data-qa="swiper-wrapper">
			<Swiper
				onSwiper={swiper => {
					const visibleSlidesIndexes = getVisibleSlidesIndexes(swiper.slides);
					handleInitSwiper(visibleSlidesIndexes);
				}}
				onSlideChange={swiper => {
					const visibleSlidesIndexes = getVisibleSlidesIndexes(swiper.slides);
					handleChangeSlide(swiper.realIndex, swiper.previousIndex, visibleSlidesIndexes);
				}}
				observeSlideChildren
				watchSlidesProgress
				className={SwiperContainer}
				slidesPerView="auto"
				spaceBetween={spaceBetween}
				watchOverflow={!isMoscow}
				navigation={{
					prevEl: '.swiper-button--prev',
					nextEl: '.swiper-button--next',
				}}
				modules={[Navigation]}
			>
				{categoriesData.map(category => (
					<SwiperSlide
						style={{ width: 'max-content' }}
						key={`swiper-slide-${category.categoryId}`}
					>
						<CategoryCard
							className={`swiper-slide ${
								isMoscow ? PopularCategoryCardMoscow : PopularCategoryCardRegion
							}`}
							categoryData={category}
							cardType={cardType}
							key={`popular-service-card-${category.categoryId}`}
							onClickHandler={onClickCard}
						/>
					</SwiperSlide>
				))}
				<SliderButton type="prev" dataQa="change-backward" />
				<SliderButton type="next" dataQa="change-forward" />
			</Swiper>
		</SwiperWrapper>
	);
};
